import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { LanguageDto } from '../../../shared/models/info/language-dto';
import { BaseApi } from './base/base-api';
import { Injectable } from '@angular/core';
import { withCache } from '@ngneat/cashew';

@Injectable({
  providedIn: 'root',
})
export class LanguageApiService extends BaseApi {
  constructor() {
    super(environment.api + 'language');
  }

  public getLanguages(nwNumberErrorMemoryId?: string): Observable<LanguageDto[]> {
    return this.http.get<LanguageDto[]>(`${this.baseUrl}/${nwNumberErrorMemoryId ?? ''}`, {
      context: withCache(),
    });
  }
}
